// @ts-expect-error TS(7016): Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import { components } from 'react-select';

import { Icon } from 'components/Icon';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ClearIndicator(props: any) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <components.ClearIndicator {...props}>
      <Icon initialColorName="todo-replace-me" name="close" size={12} />
    </components.ClearIndicator>
  );
}
